import React, { Component, useState } from 'react'
import withRoot from '../../withRoot'
import { Login as Layout } from '../../layouts'
import { Box, PasswordField, Toast } from '../index'
import { t as i18n } from 'ttag'
import { Button, makeStyles, Typography } from '@material-ui/core'
import passwordValidation from '../../utils/passwordValidation'
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11'
import { isEmpty } from 'lodash'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(8)
  },
  subheader: {
    margin: `${theme.spacing(2)}px 0px`
  },
  buttonsContainer: {
    marginTop: theme.spacing(2)
  }
}))

const ResetPassword = props => {
  const classes = useStyles()
  const { formAction, error, errorMsg, callback, tenantDomain } = props
  const { register, handleSubmit, errors } = useForm({
    reValidateMode: 'onSubmit'
  })

  const onSubmit = () => {
    if (isEmpty(errors)) {
      document.getElementById('Reset-password-container').submit()
    }
  }
  const getFields = defaultValue => {
    let fields = {
      password: defaultValue,
      confirmPassword: defaultValue
    }
    return fields
  }

  const [values, setValues] = useState(getFields(''))

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value })
  }

  return (
    <Layout>
      <Box headerTitle={i18n`Reset password`} enableLinks={false} {...props}>
        <form
          id='Reset-password-container'
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate={true}
          method='post'
          action={formAction}
        >
          <Typography
            variant='body2'
            color='textSecondary'
            className={classes.subheader}
          >
            {i18n`Passwords must be at least 8 characters and contain at least 3 of the following:  lower case letters, upper case letters, numbers and special characters. It should not contain space.`}
          </Typography>

          <PasswordField
            id={'reset-password'}
            name={'reset-password'}
            label={'Enter new password'}
            onChange={handleChange('password')}
            value={values.password}
            errors={errors}
            inputRef={register(passwordValidation())}
          />

          <input type='hidden' name='callback' value={callback} />
          <input type='hidden' name='tenantdomain' value={tenantDomain} />

          <PasswordField
            id={'reset-password2'}
            name={'reset-password2'}
            label={'Confirm password'}
            onChange={handleChange('confirmPassword')}
            value={values.confirmPassword}
            errors={errors}
            inputRef={register(passwordValidation(values.password))}
          />

          <div className={classes.buttonsContainer}>
            <Button
              data-qid={'Login-button'}
              type='submit'
              variant='contained'
              color='primary'
              fullWidth
              className={classes.button}
            >
              {i18n`Submit`}
            </Button>
          </div>
        </form>
      </Box>
      {error === 'true' && (
        <Toast
          id={'Reset-password-snackbar'}
          message={errorMsg}
          variant={'error'}
        />
      )}
    </Layout>
  )
}

export default withRoot(ResetPassword)
